import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BroadcastService } from "@bbwt/modules/broadcasting";
import { HttpResponsesHandlersFactory } from "@bbwt/modules/data-service";
import { NamingConvention } from "@mipro/classes/naming-convention";
import { NamingConventionService } from "@mipro/services/naming-convention.service";
import { PlayersAssignment, Squad } from "@project/models/squad";
import { PagedParentCrudService } from "@project/services/paged-parent.service";

@Injectable({
    providedIn: "root"
})
export class SquadService extends PagedParentCrudService<Squad> {
    urlTempl = "api/company/{parentId}/squads";
    entityTitle = "Squad";

    constructor(
        http: HttpClient,
        handlersFactory: HttpResponsesHandlersFactory,
        private broadcastService: BroadcastService,
        private namingConventionService: NamingConventionService
    ) {
        super(http, handlersFactory);
        this.entityTitle = this.namingConventionService.groupSingular;
        this.broadcastService
            .on<NamingConvention>(NamingConventionService.NamingConventionUpdatedEventName)
            .subscribe(nc => (this.entityTitle = nc.singularGroupNamingConvention));
    }

    getPlayers(squadId: string): Promise<PlayersAssignment> {
        if (!this.url) {
            Promise.resolve(<PlayersAssignment>{ assignedPatients: [], unassignedPatients: [] });
            return;
        }

        return this.handleRequest<PlayersAssignment>(
            this.http.get<PlayersAssignment>(`${this.url}/${squadId}/players`),
            this.handlersFactory.getDefault()
        );
    }

    isSquadEmpty(squadId: string): Promise<boolean> {
        return this.handleRequest<boolean>(this.http.get<boolean>(`${this.url}/${squadId}/is-empty`), this.handlersFactory.getDefault());
    }

    archive(squadId: string): Promise<Squad> {
        return this.handleRequest<Squad>(
            this.http.put<Squad>(`${this.url}/${squadId}/archive`, null),
            this.handlersFactory.getForUpdate(this.entityTitle, { successMessage: `${this.entityTitle} archived.` })
        );
    }

    restore(squadId: string): Promise<Squad> {
        return this.handleRequest<Squad>(
            this.http.put<Squad>(`${this.url}/${squadId}/restore`, null),
            this.handlersFactory.getForUpdate(this.entityTitle, { successMessage: `${this.entityTitle} restored.` })
        );
    }
}
